module.exports = __webpack_public_path__ + "img/Program-all.13ebb8ff.png";